@if (serviceName?.toUpperCase().includes('NDC') && !hideNdcUrl) {
  <a tabindex="0" [href]="ndcFareInfoUrl" target="_blank" class="fare_rules_link ndc_link">
    <i class="currency_info_icon"></i>
    <span [ngClass]="additionalClass" i18n="@@flightBasketNDCFare">What is a NDC fare?</span>
  </a>
}
